import ErrorBoundary from '../common/ErrorBoundary';
import { Route, Routes } from 'react-router-dom';
import Home from '../ivy/Home';
import Login from '../ivy/Login';
import React from 'react';
import Auth from '../ivy/Auth/Auth';
import Resume from '../ivy/Resume';
import RecruitmentEnd from '../ivy/Recruitment/RecruitmentEnd';
import IvyAdmin from '../admin/UserManagement';
import Recruitment from '../ivy/Recruitment';
import Header from '../common/Header';
import Footer from '../common/Footer';
import AdminLogin from "../admin/Login";

const Router = () => {
  return (
    <>
      <ErrorBoundary>
        <React.Suspense fallback={<></>}>
          <HeaderRouter />
        </React.Suspense>
      </ErrorBoundary>
      <ErrorBoundary>
        <React.Suspense fallback={<></>}>
          <BodyRouter />
        </React.Suspense>
      </ErrorBoundary>
      <ErrorBoundary>
        <React.Suspense fallback={<></>}>
          <FooterRouter />
        </React.Suspense>
      </ErrorBoundary>
    </>
  );
};

const HeaderRouter = () => (
  <Routes>
    <Route path={'/login'} element={<></>} />
    <Route path={'/admin*'} element={<></>} />
    <Route path={'/*'} element={<Header />} />
  </Routes>
);

const BodyRouter = () => (
  <Routes>
    <Route path={'/'} element={<Home />} />
    <Route path={'/auth'} element={<Auth />} />
    <Route path={'/login'} element={<Login />} />
    <Route path={'/resume'} element={<Resume />} />
    <Route path={'/recruitment'} element={<Recruitment />} />
    <Route path={'/recruitment/:id'} element={<RecruitmentEnd />} />

    <Route path={'/admin'} element={<AdminLogin />} />

    {/* 기업 회원가입 / 로그인 1차 스펙 제외 */}
    {/*<Route path={'/join'} element={<Join />} />*/}
  </Routes>
);

const FooterRouter = () => (
  <Routes>
    <Route path={'/login'} element={<></>} />
    <Route path={'/admin*'} element={<></>} />
    <Route path={'/*'} element={<Footer />} />
  </Routes>
);

export default Router;
